import type { SVGProps } from 'react';
const SvgIconCheck = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M14.818 4.06a.75.75 0 0 1 0 1.06l-6.721 6.721a.75.75 0 0 1-1.06 0l-3.89-3.889a.75.75 0 0 1 1.06-1.06l3.36 2.863 6.19-5.695a.75.75 0 0 1 1.06 0"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgIconCheck;
